Mousetrap.bind('b', function() { back(); });
Mousetrap.bind('s', function() { searchClients(); });
Mousetrap.bind('q', function() { logOut(); });
Mousetrap.bind('r', function() { resetDashboard(); });

function back() {
    window.history.back();
}

function searchClients() {
    $('#selected_company').select2('open');
}

$(document).off('click', '.copy-to-clipboard ').on('click', '.copy-to-clipboard ', function () {
    const link = $(this).data('link');

    const el = document.createElement('textarea');
    el.value = link;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);

    toastr.success(allLangFiles.forms.copied_to_clipboard);
});

function resetDashboard(){
    $("#selected_company").select2("trigger", "select", {
        data: { id: "default" }
    });
}

function logOut() {
    window.location.replace("/logout");
}